<template lang="pug">
  div
    form#passwordForm(@submit.prevent="onSubmit")
      .row
        .xs-12
          mr-input(label="Current password" :input-type="accountPswd.type" v-model="passwordForm.accountPassword" :v="$v.passwordForm.accountPassword" dataMrAss="current-password")
          span.show-password.font-xsmall.color-black.clickable.color-mr-purple.upper(@click="toggleShowPassword('accountPswd')" data-mr-ass="show-current-password") {{ accountPswd.text }}

      .row
        .xs-12
          mr-input(label="New password" :input-type="newPswd.type" v-model="passwordForm.newPassword" :v="$v.passwordForm.newPassword" dataMrAss="new-password")
          span.show-password.font-xsmall.color-black.clickable.color-mr-purple.upper(@click="toggleShowPassword('newPswd')" data-mr-ass="show-new-password") {{ newPswd.text }}

      .row.mt-20.mb-20
        .text-center
          button.mr-btn.btn-fixed-width.font-xsmall(data-mr-ass="save-password") Save

</template>

<script>
  import mrInput from '../../mrInput';
  import customerSvc from '../../../services/vueCustomerSvc';
  const { required } = require("vuelidate/lib/validators");


  export default {
    name: "UpdatePassword",
    components: {
      mrInput
    },

    data() {
      return {
        passwordForm: {
          accountPassword: null,
          newPassword: null
        },
        accountPswd: {
          type: 'password',
          text: 'Show'
        },
        newPswd: {
          type: 'password',
          text: 'Show'
        }
      };
    },

    validations: {
      passwordForm: {
        accountPassword: {
          required
        },
        newPassword: {
          required
        }
      }
    },

    methods: {
      onSubmit() {
        this.passwordForm.confirmPassword = this.passwordForm.newPassword;

        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        customerSvc.updatePassword(this.passwordForm)
          .then(() => {
            this.$store.dispatch('notifySuccess', 'You have successfully updated your password.');
            this.passwordForm.accountPassword = null;
            this.passwordForm.newPassword = null;
            this.passwordForm.confirmPassword = null;
            this.$v.passwordForm.$reset();
          })
          .catch((err) => {
            let errMsg = 'We were not able to update your password. Please try again or contact Color Crew';
            if (err.response.data.message) {
              errMsg = err.response.data.message;
            }

            this.$store.dispatch('notifyError', errMsg);
          });
      },

      toggleShowPassword(property) {
        this[property].type = this[property].type == 'text' ? 'password' : 'text';
        this[property].text = this[property].text == 'Hide' ? 'Show' : 'Hide';
      }
    }
   }
</script>

<style scoped lang="stylus">
  .show-password
    position absolute
    right 1em
    top 1em
    transform translateY(50%)

</style>
